module.exports = ".image {\n  width: 100%;\n  -o-object-fit: contain;\n     object-fit: contain; }\n"